import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { api } from 'services/api';

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiInput from "components/VuiInput";
import VuiButton from "components/VuiButton";
import GradientBorder from "examples/GradientBorder";

// Vision UI Dashboard assets
import radialGradient from "assets/theme/functions/radialGradient";
import palette from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";

// Authentication layout components
import CoverLayout from 'layouts/authentication/components/CoverLayout';

// Images
import bgSignIn from "assets/images/signInImage.png";

// Material-UI components for alerts
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';

function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (password !== confirmPassword) {
      setError('As senhas não correspondem.');
      return;
    }

    if (password.length < 8) {
      setError('A senha deve ter pelo menos 8 caracteres.');
      return;
    }

    setLoading(true);

    try {
      await api.post('/auth/reset-password', { token, new_password: password });
      setSuccess('Sua senha foi redefinida com sucesso! Você será redirecionado para o login.');
      setTimeout(() => {
        navigate('/authentication/sign-in');
      }, 3000);
    } catch (err) {
      setError(err.response?.data?.detail || 'Ocorreu um erro. O token pode ser inválido ou ter expirado.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <CoverLayout
      title="Redefinir Senha"
      color="white"
      description="Defina sua nova senha de acesso à sua conta."
      premotto=""
      mottoLine1="SEU LANÇAMENTO PROTEGIDO:"
      mottoLine2="SAFERDOCK"
      image={bgSignIn}
    >
      <VuiBox component="form" role="form" onSubmit={handleSubmit}>
        <VuiBox mb={2}>
          <VuiBox mb={1} ml={0.5}>
            <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
              Nova Senha
            </VuiTypography>
          </VuiBox>
          <GradientBorder
            minWidth="100%"
            padding="1px"
            borderRadius={borders.borderRadius.lg}
            backgroundImage={radialGradient(
              palette.gradients.borderLight.main,
              palette.gradients.borderLight.state,
              palette.gradients.borderLight.angle
            )}
          >
            <VuiInput type="password" placeholder="Sua nova senha..." fontWeight="500" onChange={(e) => setPassword(e.target.value)} required />
          </GradientBorder>
        </VuiBox>
        <VuiBox mb={2}>
          <VuiBox mb={1} ml={0.5}>
            <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
              Confirmar Nova Senha
            </VuiTypography>
          </VuiBox>
          <GradientBorder
            minWidth="100%"
            padding="1px"
            borderRadius={borders.borderRadius.lg}
            backgroundImage={radialGradient(
              palette.gradients.borderLight.main,
              palette.gradients.borderLight.state,
              palette.gradients.borderLight.angle
            )}
          >
            <VuiInput type="password" placeholder="Confirme sua nova senha..." fontWeight="500" onChange={(e) => setConfirmPassword(e.target.value)} required />
          </GradientBorder>
        </VuiBox>

        {error && (
          <VuiBox mb={2}>
            <Alert severity="error">{error}</Alert>
          </VuiBox>
        )}
        {success && (
          <VuiBox mb={2}>
            <Alert severity="success">{success}</Alert>
          </VuiBox>
        )}

        <VuiBox mt={4} mb={1}>
          <VuiButton type="submit" color="info" fullWidth disabled={loading}>
            {loading ? <CircularProgress size={24} color="inherit" /> : 'REDEFINIR SENHA'}
          </VuiButton>
        </VuiBox>
        <VuiBox mt={3} textAlign="center">
          <VuiTypography variant="button" color="text" fontWeight="regular">
            Lembrou sua senha?{" "}
            <VuiTypography
              component={Link}
              to="/authentication/sign-in"
              variant="button"
              color="white"
              fontWeight="medium"
            >
              Entrar
            </VuiTypography>
          </VuiTypography>
        </VuiBox>
      </VuiBox>
    </CoverLayout>
  );
}

export default ResetPassword;